<div #container [ngClass]="{'selected': isSelectedJob, 'upload-item-container': true}">
    <div class="upload-item-info">
        <div class="upload-item-id-addr">
            <span class="upload-item-id">#{{job.id | shortenJobID}}</span>
            <span class="upload-item-address">- {{job.address?.indexOf(',') > -1 ? job.address?.substring(0, job.address?.indexOf(',')) : job?.address}}</span>
        </div>
        <span class="upload-item-date" *ngIf="job?.imagesToDeliver?.length < 1 || !!(currentUploads$|async)[job?.id]; else canDeliverButton">{{job.received | date: 'd MMM y'}}</span>
      <ng-template #canDeliverButton>
        <button mat-raised-button
                class="btn btn-green deliver-btn"
                [disabled]="jobDeliverPending || deleteInProgress"
                (click)="deliverJob()">
          Deliver
          <ng-template [ngIf]="jobDeliverPending">
            <div class="lds-hourglass"></div>
          </ng-template>
        </button>
      </ng-template>
    </div>
</div>
